import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IHolderReferentialValuesFormMeta {
  month?: FormInputMeta;
  year?: FormInputMeta;
  dayUsedGlobalCard?: FormInputMeta;

  schema: any;
}

const holderReferentialValuesFormMeta = {} as IHolderReferentialValuesFormMeta;

holderReferentialValuesFormMeta.month = {
  name: "month",
  type: "text",
  label: "Mois",
  placeholder: "",
  disabled: true,
  validation: yup.string()
};

holderReferentialValuesFormMeta.year = {
  name: "year",
  type: "text",
  label: "Année",
  placeholder: "",
  disabled: true,
  validation: yup.string()
};

holderReferentialValuesFormMeta.dayUsedGlobalCard = {
  name: "dayUsedGlobalCard",
  type: "text",
  label: "Jour Utilis. Carte Globale",
  disabled: true,
  placeholder: "",
  validation: yup.string()
};


holderReferentialValuesFormMeta.schema = yup.object().shape(getValidationSchema(holderReferentialValuesFormMeta));

export default holderReferentialValuesFormMeta;